module.exports = __webpack_public_path__ + "img/bookmark-1.9b0a6b09.svg";